var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4866 13.3033C10.348 13.2894 10.1818 13.2894 10.0293 13.3033C6.7319 13.1923 4.11328 10.4875 4.11328 7.15857C4.11328 3.76026 6.85659 1 10.2649 1C13.6594 1 16.4166 3.76026 16.4166 7.15857C16.4027 10.4875 13.7841 13.1923 10.4866 13.3033Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.52823 18.4827C0.157258 20.7357 0.157258 24.4073 3.52823 26.6464C7.35887 29.2054 13.6411 29.2054 17.4718 26.6464C20.8427 24.3934 20.8427 20.7218 17.4718 18.4827C13.6551 15.9376 7.3728 15.9376 3.52823 18.4827Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.9f2b725fbed5a0ac0cd2264acaba4692.svg";
export { ForwardRef as ReactComponent };